module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/下载引流卡片-二维码底座.d4116.png";